import React, {  useState, useEffect, createContext} from 'react';
import { Route, Routes, useNavigate, NavLink} from 'react-router-dom';

import BackUp from './backUp/backUp';
import GeneralSetting from './generalSettings';
import UserHeader from './user/userHeader';
import Role from './role/role';
import License from './license/license';
import PiSetting from './piSetting/piSetting';
import ProductSetting from './productSetting/productSetting';
import User from './user/user';
import { FcSupport, FcManager, FcPackage, FcReadingEbook, FcPrint, FcTimeline, FcExport } from "react-icons/fc";

function SettingTab(props) {



  const navigate = useNavigate();
  const [showBackUpModal, setShowBackUpModal] = useState(false);

  const [activeTab, setActiveTab] = useState('general');

  useEffect(() => {

    navigate('/settingTab/user');

  }, []);


  return (
    <div className="card" style={{paddingTop : '0px', userSelect: 'none'}}>
      
      <div>

     
        
       
          <NavLink to="user" onClick={() => setActiveTab('user')}>
            <div className={`${activeTab === 'user' ? 'tab-one active-link' : 'tab-one'}`} style={{ width: '10%' }}>
              <FcManager size={35} />
              <span className="tab-text">Users</span>
            </div>
          </NavLink>
        

        <NavLink to="role" onClick={() => setActiveTab('role')}>
          <div className={`${activeTab === 'role' ? 'tab-two active-link' : 'tab-two'}`} style={{width: '12%'}}>
          <FcReadingEbook size={35}/>
            <span className="tab-text">Roles</span>
          </div>
        </NavLink>
    
      
        <NavLink to="license" onClick={() => setActiveTab('license')}>
          <div className={`${activeTab === 'license' ? 'tab-three active-link' : 'tab-three'}`} style={{width: '12%'}}>
          <FcTimeline size={35}/>
            <span className="tab-text">License</span>
          </div>
        </NavLink>

        <div className="tab-seven" style={{ width: '10%', cursor: 'pointer' }} onClick={() => setShowBackUpModal(!showBackUpModal)} >
          <FcExport size={30} />
          <span className="tab-text">Back Up</span>
        </div>

        <BackUp showModal={showBackUpModal} toggleModal={() => setShowBackUpModal(!showBackUpModal)} />

     


      </div>

      
    

 
      <Routes>

        <Route path='purchaseInvoice' element= {<PiSetting/>}/>
        <Route path='products' element= {<ProductSetting/>}/>
        <Route path='user' element={<User />} />
        <Route path='role' element= {<Role/>}/>
        <Route path='license' element= {<License/>}/>
  
        
      </Routes>

    </div>
  );
}

export default SettingTab;
